import Footer from "./components/Footer";
import PatientReferrals from "./components/PatientReferrals";
import WelcomePage from "./components/WelcomePage";

const Home = () => {
  return (
    <div className="flex flex-col gap-[32px] bg-[#F9F9FF] min-h-screen">
      <WelcomePage />
      <PatientReferrals />
      <div className="pb-20"></div>
      <Footer />
    </div>
  );
};

export default Home;
